import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { WEB_URL } from "variables/Variables.jsx";

class ArchivedDownloads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloadsList : null
    }
  }

  componentDidMount () {
    fetch("https://"+WEB_URL+"/account/api/getuserdownloads",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'token='+this.props.authDetail.token
      'body' : JSON.stringify({'token':this.props.authDetail.token})
    }).then(res => res.json())
      .then(
        (response) => {
          var latestDownload = null;
          var dl = [];
          for(var p=0;p<response.downloads.length;p++){
            latestDownload = latestDownload==null?response.downloads[p].version:latestDownload;

            if(latestDownload != response.downloads[p].version){
              dl.push(response.downloads[p]);
            }
          }
          this.setState({downloadsList : dl})
        },
        (error) => {
          
        }
      )
  }

  getUserDownloadLink(download){
    return "URL";
  }

  startDownload(download,e){
    var extpath      = "";

    if(download.path.indexOf('Zine')>-1 || download.path.indexOf('Desktop')>-1){
      extpath      = "zine_adaptiveui";
    }

    if(download.path.indexOf('Annotations')>-1){
      extpath      = "annotations_adaptiveui";
    }

    if(extpath == ""){
      extpath      = "adaptiveui";
    }

    var link = document.createElement("a");
    link.download = download.path;
    link.href = 'https://flowpaper.com/ca/'+extpath+'/'+download.path;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    e.preventDefault();
    return false;
  }

  render() {
    return (
      <div className="content">
        {this.state.downloadsList!=null ? 
        <Grid fluid>
          <Row>
            <Col md={10}>
            {this.state.downloadsList.length ? 
            <Card
                title=""
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Version</th>
                        <th className="pull-right">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.downloadsList.map((download, index) => {
                      
                        return (
                            <tr key={`${download.id}`}>
                                <td><a href="#" onClick={(e) => this.startDownload(download, e)}>{download.name}</a></td>
                                <td>{download.version}</td>
                                <td><button type="submit" onClick={(e) => this.startDownload(download, e)} className="pull-right btn btn-info btn-xs btn-fill" style={{marginRight:10}}>Download</button></td>
                            </tr>
                        );
                    })}
                    </tbody>
                  </Table>
                }
              />:<Card
              title=""
              category="Quota Used XX/XX publications"
              ctTableFullWidth
              ctTableResponsive
              content={
                <div style={{margin:20}}>No uploaded publications</div>
              }/>}
            </Col>
          </Row>
        </Grid>
        :<div className="spinner-grow text-primary" role="status">
        <span className="sr-only">Loading...</span>
        </div>}
      </div>
    );
  }
}

export default ArchivedDownloads;
